export default __webpack_public_path__ + "static/media/lisieux13.814ed02e.jpg";